import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatValidNumber, getDifferenceWithPrecision } from 'utils'

const ClubCardModalTableRow = (
  { 'clubCards@Current': clubCardsApplicationCurrent, channel, clubCardsCurrent, maxBarValue, no, shareClubCard },
  context,
) => {
  const { t: translate } = useTranslation()
  const barWidth = Math.round(shareClubCard / maxBarValue)

  return (
    <div className="club-card-modal-table-row">
      <div className={classNames('row-wrapper flex-row', { 'no-first': no === 1 })}>
        <div className="cell-bar" style={{ width: `${barWidth}%` }} />

        <div className="cell cell-no">{no}</div>

        <div className="cell cell-company">
          {/* TODO: Add logo per channel */}
          {/* <div className={classNames('flag', `flag-${channel}`)} /> */}
          {channel}
        </div>
        <div className="cell cell-shareClubCard">
          {
            getDifferenceWithPrecision({
              number: shareClubCard,
              precision: 0,
              translate,
            }).value
          }
        </div>

        <div className="cell cell-newClubCards">{formatValidNumber(clubCardsCurrent)}</div>

        <div className="cell cell-application">{formatValidNumber(clubCardsApplicationCurrent)}</div>
      </div>
    </div>
  )
}

ClubCardModalTableRow.propTypes = {
  'clubCards@Current': PropTypes.number,
  channel: PropTypes.string,
  clubCardsCurrent: PropTypes.number,
  maxBarValue: PropTypes.number,
  no: PropTypes.number.isRequired,
  shareClubCard: PropTypes.number,
}

export default ClubCardModalTableRow
